<template>
  <div style="max-width: 200px">
    <ViewListFieldValue
      v-if="isListField"
      :contactName="contactName"
      :field="fieldSchema"
      :value="fieldValue"
      @click.native.stop
    />

    <SecretFieldReveal
      v-else-if="isSecretField"
      :contactId="contactId"
      :field="field"
    />

    <div class="text-ellipsis" v-else>
      {{ fieldValue }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactsTableCell',
  components: {
    SecretFieldReveal: () =>
      import('@/components/formFields/secretField/SecretFieldReveal.vue'),
    ViewListFieldValue: () =>
      import(
        '@/views/contacts/components/specialContactFields/ViewListFieldValue.vue'
      ),
  },
  props: {
    contactId: String,
    field: String,
    fieldValue: {},
    fieldSchema: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    contactName: String,
  },
  computed: {
    fieldType() {
      return this.fieldSchema?.type;
    },
    isListField() {
      return ['list', 'related_contacts'].includes(this.fieldType);
    },
    isSecretField() {
      return this.fieldType === 'secret' && this.fieldValue;
    },
  },
};
</script>
